import { AxiosResponse } from "axios"

export function extractData(res: AxiosResponse) {
  return res.data
}
